import React from "react";
import AccountSettingsComponent from "../components/account-settings";

export default function AccountSettingsPage() {
  return (
    <div className="common-section">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center py-8">
          <AccountSettingsComponent />
        </div>
      </div>
    </div>
  );
}
